/**
 * TutorAccountScreen — la route `account` d'un tuteur : « Mon compte » est la feuille de profil de la
 * coquille, il n'y a plus de page. La route y ramène, la feuille ouverte (`useTutorAccountRedirect`).
 */
import { useTutorAccountRedirect } from "./useTutorAccountRedirect"

export function TutorAccountScreen() {
    useTutorAccountRedirect()
    return null
}
